export default __webpack_public_path__ + "static/media/(41).e3f4d398.jpg";